<app-header *ngIf= "getHeader"></app-header>
<main>
	<router-outlet (activate)="changeOfRoutes($event)"></router-outlet>
</main>
<app-footer *ngIf= "getHeader"></app-footer>